import axios from "axios";
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
export const money = (value = 0) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(value);
export const errorText = error => {
  const detail = error.response?.data?.detail;
  return Array.isArray(detail) ? detail.map(item => item.msg).join(". ") : typeof detail === "string" ? detail : "Tidak dapat memproses permintaan. Silakan coba lagi.";
};
export const today = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
export async function downloadFile(path, filename) {
  let response;
  try { response = await api.get(path, { responseType: "blob" }); }
  catch (error) {
    if (error.response?.data instanceof Blob) {
      try {error.response.data = JSON.parse(await error.response.data.text());} catch { /* Keep the generic failure for non-JSON responses. */ }
    }
    throw error;
  }
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export const downloadPdf = downloadFile;